<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" :attach="attach !== undefined" offset-y max-height="280")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl(v-bind="attrs" v-on="on" :class="error ? 'error-border-menu' : 'border-menu'" flat outlined height="48" min-width="240")
        .d-flex.align-center.fill-height.px-4
          div.flex-grow-1(v-if="Object.keys(value).length > 0")
            .text-md.text-left(style="font-size: 15px !important;") {{ value.invoice_no }}
          .text-sm.flex-grow-1.neutral500--text.text-left(v-else) Select invoice
          v-icon(size="24") $yzi-chevron-down
      div.text-xs.danger500--text.ml-3.mt-1.mb-2(v-show="error") This field is required
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined placeholder="Search invoice" dense hide-details autofocus @input="queryChanged")
        v-divider
        div.d-flex.justify-center(v-if="isFetching")
          v-progress-linear(:width="3" rounded color="primary" indeterminate)
      div(v-for="item in invoices")
        div.d-flex.align-center.px-4.py-3(v-if="isItemDisabled(item)" style="background-color: var(--v-neutral300)")
          div.flex-grow-1
            div.text-sm.neutral700--text {{ item.invoice_no }} - {{ item.record_date | displayDate }}
            div.text-xs.neutral500--text {{ item.seller.sold_by }}
        div.d-flex.align-center.px-4.py-3.clickable.hover-bg(v-else @click="selectItem(item)")
          div.flex-grow-1
            div.text-sm.neutral700--text {{ item.invoice_no }} - {{ item.record_date | displayDate }}
            div.text-xs.neutral500--text {{ item.seller.sold_by }}
        v-divider
      template(v-if="next")
        div.d-flex.align-center.px-4.py-3.clickable(@click="fetchNext(next)")
          div.text-sm.font-semibold.flex-grow-1.info600--text.text-center Load more
      template(v-if="!invoices.length")
        .px-4.py-3 No results match

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'

export default {
  components: { },
  props: ['value', 'error', 'attach'],
  data: () => ({
    isLoading: false,
    isFetching: false,
    show: false,
    itemName: null,
    next: null,
    invoices: [],
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showCreateButton() {
      if (this.itemName) {
        return true
      }
      return false
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.fetchInvoices()
      } else {
        this.$emit('change')
        this.clearList()
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchInvoices () {
      this.isFetching = true
      let params = {
        page_size: 10,
      }
      if (this.itemName) { params.search = this.itemName }
      this.$axios.get(`/clinics/${this.company.slug}/inventory_invoices`, { params })
        .then(resp => {
          this.invoices = resp.data.results
          this.next = resp.data.next
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchNext (next) {
      this.isFetching = true
      const url = new URL(next)
      const endpoint = next.replace(url.origin, '')
      this.$axios.get(endpoint)
        .then(resp => {
          this.invoices = [ ...this.invoices, ...resp.data.results]
          this.next = resp.data.next
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    queryChanged: debounce(function () {
      this.fetchInvoices()
    }, 750),
    selectItem (item) {
      this.$emit('input', item)
      this.show = false
      this.itemName = ''
    },
    isItemDisabled(item) {
      return this.value && this.value.id === item.id
    },
    clearList () {
      this.invoices = []
      this.next = null
    }
  }
}
</script>

<style lang="scss" scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
</style>